/* tslint:disable */
/* eslint-disable */

/**
 * 0 = Mr
 * 
 * 1 = Mrs
 * 
 * 2 = Miss
 * 
 * 3 = Ms
 * 
 * 4 = Mx
 * 
 * 5 = Dr
 * 
 * 6 = Other
 */
export enum Title {
  Mr = 0,
  Mrs = 1,
  Miss = 2,
  Ms = 3,
  Mx = 4,
  Dr = 5,
  Other = 6
}
